import { PhoneBehaviourDto } from '../../../interfaces/dtos/PhoneBehaviourDto';
import { PhoneDto } from '../../../interfaces/dtos/PhoneDto';
import { Phones } from '../../../interfaces/Phones';

export default function transformPhones(dto: PhoneDto, behaviours: PhoneBehaviourDto): Phones {
  return {
    cell: dto.phoneNumberCell,
    fax: dto.phoneNumberFax,
    home: dto.phoneNumberHome,
    work: dto.phoneNumberWork,
    workExtension: dto.phoneNumberWorkExtension,
    behaviours: {
      readOnlyPhoneNumbers: behaviours.readOnlyPhoneNumbers,
      showCellPhoneNumber: behaviours.showCellPhoneNumber,
      showFaxPhoneNumber: behaviours.showFaxPhoneNumber,
      showWorkPhoneNumber: behaviours.showWorkPhoneNumber,
      showSection: behaviours.showSection,
    },
  };
}
